import type { ColdProsAnalytics, LeadDetail, PaginationInfo } from './types'

const BASE_URL = '/dashboard/coldpros-analytics'

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

export async function fetchStats(): Promise<ColdProsAnalytics> {
  const response = await fetch(`${BASE_URL}/stats`)
  if (!response.ok) throw new Error('Failed to fetch stats')
  return response.json()
}

export async function fetchLeads(params: {
  page?: number; per_page?: number; search?: string
}): Promise<{ leads: LeadDetail[]; pagination: PaginationInfo }> {
  const sp = new URLSearchParams()
  if (params.page) sp.set('page', params.page.toString())
  if (params.per_page) sp.set('per_page', params.per_page.toString())
  if (params.search) sp.set('search', params.search)
  const response = await fetch(`${BASE_URL}/leads?${sp.toString()}`)
  if (!response.ok) throw new Error('Failed to fetch leads')
  return response.json()
}

export async function uploadFile(uploadType: string, file: File): Promise<{ status: string; rows_imported: number }> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('upload_type', uploadType)
  const response = await fetch(`${BASE_URL}/upload`, {
    method: 'POST', headers: { 'X-CSRF-Token': csrfToken() }, body: formData,
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.message || 'Upload failed')
  return data
}

export function getExportUrl(): string {
  return `${BASE_URL}/export.csv`
}
